"use strict";

var _objectWithoutProperties = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _excluded = ["durationInFrames", "times", "children", "name"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loop = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var Sequence_1 = require("../Sequence");

var use_video_config_1 = require("../use-video-config");

var validate_duration_in_frames_1 = require("../validation/validate-duration-in-frames");

var Loop = function Loop(_ref) {
  var durationInFrames = _ref.durationInFrames,
      _ref$times = _ref.times,
      times = _ref$times === void 0 ? Infinity : _ref$times,
      children = _ref.children,
      name = _ref.name,
      props = _objectWithoutProperties(_ref, _excluded);

  var _ref2 = (0, use_video_config_1.useVideoConfig)(),
      compDuration = _ref2.durationInFrames;

  (0, validate_duration_in_frames_1.validateDurationInFrames)(durationInFrames, 'of the <Loop /> component');

  if (typeof times !== 'number') {
    throw new TypeError("You passed to \"times\" an argument of type ".concat(typeof times, ", but it must be a number."));
  }

  if (times !== Infinity && times % 1 !== 0) {
    throw new TypeError("The \"times\" prop of a loop must be an integer, but got ".concat(times, "."));
  }

  if (times < 0) {
    throw new TypeError("The \"times\" prop of a loop must be at least 0, but got ".concat(times));
  }

  var maxTimes = Math.ceil(compDuration / durationInFrames);
  var actualTimes = Math.min(maxTimes, times);
  var style = props.layout === 'none' ? undefined : props.style;
  return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
    children: new Array(actualTimes).fill(true).map(function (_, i) {
      return (0, jsx_runtime_1.jsx)(Sequence_1.Sequence // eslint-disable-next-line react/no-array-index-key
      , {
        durationInFrames: durationInFrames,
        from: i * durationInFrames,
        name: name,
        showLoopTimesInTimeline: actualTimes,
        showInTimeline: i === 0,
        layout: props.layout,
        style: style,
        children: children
      }, "loop-".concat(i));
    })
  });
};

exports.Loop = Loop;